import { deleteFileUploadClient } from '../clients/deleteFileUploadClient';
import { registerMutation } from 'data-fetching-client';
export const DELETE_FILE_UPLOAD_MUTATION = registerMutation({
  fieldName: 'DELETE_FILE_UPLOAD',
  args: ['fileIds'],
  fetcher: deleteFileUploadClient
});